import { computed, CreateComputedOptions, CreateSignalOptions, Signal, signal, WritableSignal } from '@angular/core';
import _ from 'lodash';

export function customSignal<T>(initialValue: T, options: CreateSignalOptions<any> = {}): WritableSignal<T> {
  options.equal ??= typeof initialValue === 'object' ? _.isEqual : undefined;
  return signal(_.cloneDeep(initialValue), options);
}

export function customComputed<T>(computation: () => T, options: CreateComputedOptions<any> = {}): Signal<T> {
  options.equal ??= (a: T, b: T) => {
    if (typeof a === 'object') return _.isEqual(a, b);
    return Object.is(a, b);
  };
  return computed(computation, options);
}
